// Chakra imports
import {
  Box,
  Button,
  Flex,
  Grid,
  Icon,
  Spacer,
  Text,
  useColorMode,
  useColorModeValue,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Link
} from "@chakra-ui/react";
// Assets
import BackgroundCard1 from "assets/img/BackgroundCard1.png";
// Custom components
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import IconBox from "components/Icons/IconBox";
import { MastercardIcon, VisaIcon } from "components/Icons/Icons";
import { HSeparator } from "components/Separator/Separator";
import BillingRow from "components/Tables/BillingRow";
import FAQRow from "components/Tables/FAQRow";
import TransactionRow from "components/Tables/TransactionRow";
import React from "react";
import { getGlobal } from "config/global";
import { RocketIcon } from "components/Icons/Icons";


import { BiSupport } from "react-icons/bi";
import {
  FaPaypal,
  FaPencilAlt,
  FaRegCalendarAlt,
  FaWallet,
} from "react-icons/fa";
import { RiMastercardFill } from "react-icons/ri";
import {
  billingData,
  invoicesData,
  newestTransactions,
  olderTransactions,
} from "variables/general";

function Support() {
  // Chakra color mode
  const iconBlue = useColorModeValue("blue.500", "blue.500");
  const textColor = useColorModeValue("gray.700", "white");
  const borderColor = useColorModeValue("#dee2e6", "transparent");
  const { colorMode } = useColorMode();
  let me = getGlobal("me")
  let faqs =
    [
      {
        title: "آیا می‌توانم امکانات خاص مورد نیاز خود را سفارش دهم تا به صورت اختصاصی وجود دارد؟",
        text: "بله، ما در حال توسعه امکانات مختلف هستیم، بنابراین پیشنهادات و نیازهای خاص شما بررسی شده و در صورت امکان پیاده سازی خواهد شد."
      },
      {
        title: "در صورت پایان طرح فعلی و برگشت به طرح پایه، نمایشگاه ها و اطلاعاتم چه می‌شود؟",
        text: "تا یک ماه بخش های مازاد بر پلن پایه با اعلان پایان طرح نمایش داده میشوند. پس از آن حذف خواهند شد."
      },
      {
        title: "آیا قبل از خرید نسخه آزمایشی وجود دارد تا با امکانات آشنا شوم؟",
        text: "بله، علاوه بر نسخه پایه که امکان ساخت نمایشگاه و ایستگاه های محدود دارد، نسخه آزمایشی با امکانات بیشتر فراهم شده است تا بتوانید بهتر با نمایشگاه آشنا شوید. هر اکانت یکبار امکان فعالسازی آن را خواهد داشت."
      },
      {
        title: "امکان ارتقا پلن وجود دارد؟",
        text: "از پلن پایه یا خوش آمدگویی به هر پلن دیگری میتوانید تغییر دهید. اما جز این دو پلن، پلن های دیگر را نمیتوانید تغییر دهید."
      },
      {
        title: "نیاز به نمایشگاه های بیشتر یا ایستگاه های بیشتر از محدودیت های پلن های موجود داریم؟",
        text: "اگر سازمانی هستید، یا نیازمندی بیشتری از محدودیت های پلن ها دارید، کافی است با ما تماس بگیرید."
      },
      {
        title: "فایل های آپلود شده را چه مدت نگهداری می‌کنید؟",
        text: "به صورت نامحدود، تا زمانی که شما آن را حذف کنید جز در صورت پایان طرح فعال که مقدار مازاد حذف خواهد شد."
      },
      {
        title: "آدرس نمایشگاه من، مختص به خودم خواهد بود؟",
        text: "بله، تا زمانی که اقدام به حذف نمایشگاه نکرده باشید، آدرس آن اختصاصی شماست."
      }
    ]

  return (
    <Flex direction='column' pt={{ base: "120px", md: "75px" }}>
      <Grid templateColumns={{ sm: "1fr", lg: "2fr 1.2fr" }} templateRows='1fr'>
        <Box>
          <Grid
            templateColumns={{
              sm: "1fr",
              md: "1fr 1fr",
              xl: "1fr 1fr 1fr 1fr",
            }}
            templateRows={{ sm: "auto auto auto", md: "1fr auto", xl: "1fr" }}
            gap='26px'>
            <Card
              backgroundImage={
                colorMode === "dark"
                  ? "linear-gradient(200deg, #005db3 0%, #421576 100%)"
                  : BackgroundCard1
              }
              backgroundRepeat='no-repeat'
              background='cover'
              bgPosition='10%'
              p='16px'
              h={{ sm: "220px", xl: "100%" }}
              gridArea={{ md: "1 / 1 / 2 / 3", xl: "1 / 1 / 2 / 3" }}>
              <CardBody h='100%' w='100%'>
                <Flex
                  direction='column'
                  color='white'
                  h='100%'
                  p='0px 10px 20px 10px'
                  w='100%'>
                  <Flex justify='space-between' align='center'>
                    <Text fontSize='md' fontWeight='bold'>
                      تماس با پشتیبانی
                    </Text>
                    <Icon
                      as={BiSupport}
                      w='48px'
                      h='auto'
                      color='#fff'
                    />
                  </Flex>
                  <Spacer />
                  <Flex direction='column'>
                    <Box>
                      <Link
                        href={"tel:+982166539041"}
                        fontSize='2xl'
                        letterSpacing='2px'
                        fontWeight='bold'>
                        021-66539041
                      </Link>
                    </Box>
                    <Flex mt='14px'>
                      <Flex direction='column' me='34px'>
                        <Text fontSize='xs'>تماس ضروری</Text>
                        <Link href={"tel:+989112161695"} fontSize='xs' fontWeight='bold'>
                          09112161695
                        </Link>
                      </Flex>
                      <Flex direction='column'>
                        <Text fontSize='xs'>ایمیل</Text>
                        <Link href={"mailto:info@tpan.ir"} fontSize='xs' fontWeight='bold'>
                          info@tpan.ir
                        </Link>
                      </Flex>
                    </Flex>
                  </Flex>
                </Flex>
              </CardBody>
            </Card>
            <Card p='16px' display='flex' align='center' justify='center'>
              <CardBody>
                <Flex direction='column' align='center' w='100%' py='14px'>
                  <IconBox as='box' h={"60px"} w={"60px"} bg={iconBlue}>
                    <Icon h={"24px"} w={"24px"} color='white' as={FaWallet} />
                  </IconBox>
                  <Flex
                    direction='column'
                    m='14px'
                    justify='center'
                    textAlign='center'
                    align='center'
                    w='100%'>
                    <Text fontSize='md' color={textColor} fontWeight='bold'>
                      موجودی
                    </Text>
                    <Text
                      mb='24px'
                      fontSize='xs'
                      color='gray.400'
                      fontWeight='semibold'>
                      مقدار موجودی به تومان
                    </Text>
                    <HSeparator />
                  </Flex>
                  <Text dir="ltr" fontSize='lg' color={textColor} fontWeight='bold'>
                    {"+ "} {me.balance.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}
                  </Text>
                </Flex>
              </CardBody>
            </Card>
            <Card p='16px' display='flex' align='center' justify='center'>
              <CardBody>
                <Flex
                  direction='column'
                  align='center'
                  justify='center'
                  w='100%'
                  py='14px'>
                  <IconBox as='box' h={"60px"} w={"60px"} bg={iconBlue}>
                    <Icon h={"24px"} w={"24px"} color='white' as={RocketIcon} />
                  </IconBox>
                  <Flex
                    direction='column'
                    m='14px'
                    justify='center'
                    textAlign='center'
                    align='center'
                    w='100%'>
                    <Text fontSize='md' color={textColor} fontWeight='bold'>
                      پلن
                    </Text>
                    <Text
                      mb='24px'
                      fontSize='xs'
                      color='gray.400'
                      fontWeight='semibold'>
                      محدودیت های سامانه
                    </Text>
                    <HSeparator />
                  </Flex>
                  <Text fontSize='lg' color={textColor} fontWeight='bold'>
                    {me?.plan?.title || "پایه"}
                  </Text>
                </Flex>
              </CardBody>
            </Card>
          </Grid>
          <Card p='16px' mt='24px'>
            <CardHeader>
            </CardHeader>
            <CardBody>
              <Text textAlign={"justify"} fontSize={"sm"} p="10px" lineHeight={"30px"}>
                <Text as="span" color={"green.300"}>
                  تــور مجــازی ترنـــج
                </Text>{"، "}
                جایی است که تخیل و واقعیت به یکدیگر آمیخته و تجربه‌ای نوآورانه و منحصربه‌فرد از دنیای مجازی را برای شما فراهم می‌کند.
                پنل مدیریتی ما به شما این امکان را می‌دهد تا به آسانی نمایشگاه خود را ایجاد، مدیریت و سفارشی کنید.
                <br />
                ما مشتاقانه به تأمین یک تجربه بی‌نظیر از نمایشگاه مجازی پیشرفته متعهدیم. برای ما، پشتیبانی نه تنها یک وعده است، بلکه اصل اساسی در ارائه خدمات به شما محسوب می‌شود. تیم ما آماده است که در هر مرحله از ایجاد، مدیریت و اجرای نمایشگاه مجازی شما را همراهی کند.
                <br />
                اطمینان می‌دهیم که در هر لحظه که نیاز به راهنمایی، پشتیبانی یا رفع اشکال داشتید، تیم پشتیبانی ما آماده است تا شما را در کوتاه‌ترین زمان ممکن یاری کند، کافی است با ما تماس بگیرید.
              </Text>
            </CardBody>
          </Card>
        </Box>
        <Card
          p='22px'
          my={{ sm: "24px", lg: "0px" }}
          ms={{ sm: "0px", lg: "24px" }}>
          <CardHeader>
            <Flex justify='space-between' align='center' mb='1rem' w='100%'>
              <Text fontSize='lg' color={textColor} fontWeight='bold'>
                سوالات متداول
              </Text>
            </Flex>
          </CardHeader>
          <CardBody>
            <Grid w='100%'>
              <Accordion allowToggle defaultIndex={[0]}>
                {faqs.map((row, idx) => {
                  return (
                    <AccordionItem>
                      <AccordionButton>
                        <Box flex='1' textAlign='right' p={"5px 0px 5px 0px"}>
                          <Text fontSize={"sm"} color={textColor}>
                            {row.title}
                          </Text>
                        </Box>
                        <AccordionIcon />
                      </AccordionButton>
                      <AccordionPanel pb={4}>
                        <Text p={"5px 20px 10px 0px"} fontSize={"xs"}>
                          {row.text}
                        </Text>
                      </AccordionPanel>
                    </AccordionItem>
                  );
                })}
              </Accordion>

            </Grid>
          </CardBody>
        </Card>
      </Grid>
    </Flex>
  );
}

export default Support;
